import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import { Header } from "./Header";
import { GlobalNav } from "./GlobalNav";
import { DevModeIndicator } from "./DevModeIndicator";
import {
  HEADER_HEIGHT,
  NAV_SIDEBAR_WIDTH_COLLAPSED,
  NAV_SIDEBAR_WIDTH_EXPANDED,
} from "@/config/data";

interface LayoutProps {
  children: React.ReactNode;
}

export const Layout: React.FC<LayoutProps> = ({ children }) => {
  const location = useLocation();
  const [collapsed, setCollapsed] = useState(
    () => localStorage.getItem("oos-sidebar-collapsed") === "true",
  );

  const onTaskDetailPage = location.pathname.startsWith("/jobs/");
  const sidebarWidth = onTaskDetailPage
    ? 0
    : collapsed
      ? NAV_SIDEBAR_WIDTH_COLLAPSED
      : NAV_SIDEBAR_WIDTH_EXPANDED;

  const handleCollapse = (val: boolean) => {
    localStorage.setItem("oos-sidebar-collapsed", String(val));
    setCollapsed(val);
  };

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">
      <Header />
      <div className="flex flex-1" style={{ paddingTop: HEADER_HEIGHT }}>
        <GlobalNav collapsed={collapsed} onCollapsedChange={handleCollapse} />
        <main
          className="flex-1 flex flex-col overflow-y-scroll"
          style={{
            marginLeft: sidebarWidth,
            maxHeight: `calc(100vh - ${HEADER_HEIGHT}px)`,
            transition: "margin-left 200ms ease",
          }}
        >
          {children}
        </main>
      </div>
      {import.meta.env.DEV && <DevModeIndicator />}
    </div>
  );
};
